const CONTENT_DISPOSITION_RE = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i;

export function extractFilename(contentDisposition) {
	const match = contentDisposition?.match(CONTENT_DISPOSITION_RE);
	return match?.[3] ?? 'download';
}

export function triggerBlobDownload(blob, filename) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}
